import MBGIcon from 'assets/svg/mbg/mbg-icon.svg'
import PavilionIcon from 'assets/svg/pavilion/pavilion-icon.svg'
import RalalifoodIcon from 'assets/svg/ralalifood/ralalifood-icon.svg'
import RalaliPlusIcon from 'assets/svg/ralaliplus/ralaliplus-icon.svg'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const ServicesSection = styled.section`
  width: ${theme.layout.containerWidth};
  padding: 0 24px;
  margin: 0 auto;
`

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  gap: 24px;
`

const ServiceCard = styled.div`
  background: ${theme.colors.blueDark};
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
`

const ServicesComponent = (): JSX.Element => {
  const { t } = useTranslation('home')

  return (
    <ServicesSection>
      <ServiceGrid>
        <Link href={`${WEB_DESKTOP_RALALI_URL}/grow`}>
          <ServiceCard>
            <PavilionIcon width="50" />
            <div>
              <Typography type="blabel" color="white">
                {t('SERVICES_GROW_TITLE')}
              </Typography>
              <Typography
                color="white"
                type="rparagraph"
                fontSize={12}
              >
                {t('SERVICES_GROW_DESC')}
              </Typography>
            </div>
          </ServiceCard>
        </Link>
        <Link href={`${WEB_DESKTOP_RALALI_URL}/solutions/plus`}>
          <ServiceCard>
            <RalaliPlusIcon width="60" />
            <div>
              <Typography type="blabel" color="white">
                {t('SERVICES_PLUS_TITLE')}
              </Typography>
              <Typography
                color="white"
                type="rparagraph"
                fontSize={12}
              >
                {t('SERVICES_PLUS_DESC')}
              </Typography>
            </div>
          </ServiceCard>
        </Link>
        <Link href={`${WEB_DESKTOP_RALALI_URL}/food`}>
          <ServiceCard>
            <RalalifoodIcon width="60" />
            <div>
              <Typography type="blabel" color="white">
                {t('SERVICES_FOOD_TITLE')}
              </Typography>
              <Typography
                color="white"
                type="rparagraph"
                fontSize={12}
              >
                {t('SERVICES_FOOD_DESC')}
              </Typography>
            </div>
          </ServiceCard>
        </Link>
        <Link
          href={`${WEB_DESKTOP_RALALI_URL}/pavilion/government-project/makan-bergizi-gratis`}
        >
          <ServiceCard>
            <MBGIcon width="60" />
            <div>
              <Typography type="blabel" color="white">
                {t('SERVICES_MBG_TITLE')}
              </Typography>
              <Typography
                color="white"
                type="rparagraph"
                fontSize={12}
              >
                {t('SERVICES_MBG_DESC')}
              </Typography>
            </div>
          </ServiceCard>
        </Link>
      </ServiceGrid>
    </ServicesSection>
  )
}

export default ServicesComponent
